import { LoadingContent } from '../components/feedback';
import { useState } from 'react';
import type { McpPolicy } from '@mcpanel/core';
import { api } from '../api/client';
import { useApp, errorMessage } from '../app-context';
import { usePoll } from '../hooks/usePoll';
import { StepUpDialog } from '../components/StepUpDialog';
import { ErrorAlert } from '../components/ui';
export function McpPolicySection() {
  const { me, notify } = useApp();
  const policy = usePoll(() => api.mcpPolicy(), 60000);
  const [pending, setPending] = useState<McpPolicy>();
  const [busy, setBusy] = useState(false);
  if (me?.user?.role !== 'owner') return null;
  const save = async () => {
    if (!pending) return;
    setBusy(true);
    setPending(undefined);
    try {
      await api.setMcpPolicy(pending);
      await policy.reload();
      notify('AI からの変更の設定を保存しました');
    } catch (error) {
      notify(errorMessage(error), true);
    } finally {
      setBusy(false);
    }
  };
  return (
    <section className="card">
      <div className="card-header">
        <h2 data-search-id="mcp-policy">AI からの変更</h2>
      </div>
      <LoadingContent loading={!policy.data && policy.loading} shape="settings">
        <div className="card-body stack">
          <p className="small muted">
            標準では設定・ソフト・Mod・サーバー作成をすぐ実行します。削除・復元・edge
            の反映と危険なコマンドは承認が必要です。起動・停止・再起動とスナップショット作成はどちらの設定でも直接実行します。
          </p>
          <ErrorAlert error={policy.error} />
          <label className="field">
            変更の段階
            <select
              className="input"
              aria-label="AI からの変更"
              disabled={busy || !policy.data}
              value={policy.data?.mode ?? 'standard'}
              onChange={(e) => setPending({ mode: e.target.value as McpPolicy['mode'] })}
            >
              <option value="standard">標準</option>
              <option value="approval_required">すべて承認が要る</option>
            </select>
          </label>
          <p className="small muted">変更にはオーナーのワンタイムコードが必要です。</p>
        </div>
      </LoadingContent>
      {pending && <StepUpDialog onSuccess={() => void save()} onCancel={() => setPending(undefined)} />}
    </section>
  );
}
